import GET_ARTICLES from "../class/getArticles"; 

export default function RECRUIT() {

  setTimeout(() => {

    // 記事リストの初期化
    const getArticle = new GET_ARTICLES('.recruit_provided__list');
    getArticle.makeItem = (item) => {
      if (String(item.id) === '12' || String(item.id) === '13') {
        return ''; 
      }
      return `
      <li>
        <a href="${item.href}" class="block-recruit__link">
          <figure class="thumb">
            <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
          </figure>
          <div class="text_wrap">
            <p class="ttl${(item.is_new) ? ' is-new' : ''}"><span>${item.title}</span></p>
            <span class="sub_ttl">${item.desc && item.desc.length > 200 ? item.desc.slice(0, 200) + '...' : (item.desc || '')}</span>
          </div> 
          <svg class="icon icon_arrow" width="12" height="11">
            <use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use>
          </svg>
        </a>
      </li>`;
    };
    getArticle.render();

    setTimeout(() => {
      if (window.location.hash === '#provided') {
        const target = document.querySelector('#provided');
        if (target) {
          const headerHeight = 100; 
          
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight + 100;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth' 
          });
        }
      }
    }, 300);

  }, 100);
}